<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable width="600" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card v-if="data">
        <v-toolbar flat>
          <v-toolbar-title>Detalle de dosificacion</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" icon dark @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <v-card-title>
            <v-btn small outlined color="info" @click="showEdit(data)"> <v-icon class="ma-1">mdi-pencil</v-icon> Editar </v-btn>
            <v-spacer></v-spacer>
          </v-card-title>

          <p class="px-2" v-if="data.sucursal"><strong>sucursal:</strong> {{ data.sucursal.ciudad }}</p>
          <p class="px-2" v-if="data.num_factura"><strong>num_factura:</strong> {{ data.num_factura }}</p>
          <p class="px-2" v-if="data.autorizacion"><strong>autorizacion:</strong> {{ data.autorizacion }}</p>
          <p class="px-2" v-if="data.codigo_dosificacion"><strong>codigo_dosificacion:</strong> {{ data.codigo_dosificacion }}</p>
          <p class="px-2" v-if="data.fecha_limite"><strong>fecha_limite:</strong> {{ data.fecha_limite }}</p>
          <p class="px-2" v-if="data.nit"><strong>nit:</strong> {{ data.nit }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: { editedIndex: { type: Number, default: -1 } },
  data: () => ({
    data: null,
    dialog: false,
  }),

  methods: {
    showDialog(item) {
      this.dialog = true;
      this.data = item;
    },
    closeDialog() {
      this.dialog = false;
      this.data = null;
    },
    showEdit(dosificacion) {
      this.$emit('showedit', dosificacion, true);
      this.closeDialog();
    },
  },
};
</script>
